import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';
import { hasRoleLandlord, hasRoleAdmin } from 'common/userRoles';
import {
  MARKETING_PARTNER_LISTING_UPDATE_STATUS_WITHDRAW_FROM_MARKET,
  MARKETING_PARTNER_LISTING_UPDATE_STATUS_TEMPORARILY_OFF_MARKET,
} from 'common/marketingPartnerListingConstants';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

import useBranch from 'client/hooks/useBranch';

const SrPartnerMarketingListingStatusUpdateModal = ({
  onClose,
  partner,
  marketingPartnerListing,
  onWithdrawClick,
  appUrl,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const { currentUser } = useBranch({
    currentUser: ['currentUser'],
  });

  const isLandlord = hasRoleLandlord(currentUser.roles);

  const isAdmin = hasRoleAdmin(currentUser.roles);
  const onAdminWithdrawClick = () => {
    global.location.href =
      `${appUrl}/partner/${partner.slug}` +
      `/marketing-listing/${marketingPartnerListing.id}` +
      `/${MARKETING_PARTNER_LISTING_UPDATE_STATUS_WITHDRAW_FROM_MARKET}`;
  };

  return (
    <SrModalV2
      showCloseButton={false}
      disableAnimation={isSmallScreen}
      contentMaxWidth={!isSmallScreen ? '400px' : null}
      centerContent
    >
      <SrBox width="100%">
        <SrBox margin="0 10px">
          <SrBox marginBottom="26px">
            <SrText
              color="white"
              font="greycliff"
              fontSize="26px"
              weight="800"
              align="center"
              display="block"
            >
              {marketingPartnerListing.listing.addressStreetDisplay}
            </SrText>
          </SrBox>
          <SrLink to={`/partner/${partner.slug}/market-property/${marketingPartnerListing.id}`}>
            <SrBox backgroundColor="rgba(255, 255, 255, 0.85)" borderRadius="14px 14px 0 0">
              <SrBox
                height="70px"
                paddingTop="20px"
                boxSizing="border-box"
                borderBottom="1px solid #a1a1a1"
              >
                <SrText
                  color="blue300"
                  font="greycliff"
                  fontSize="26px"
                  align="center"
                  weight="800"
                  display="block"
                >
                  Edit Listing Details
                </SrText>
              </SrBox>
            </SrBox>
          </SrLink>
          <SrLink
            to={
              `/partner/${partner.slug}/marketing-listing/${marketingPartnerListing.id}` +
              `/${MARKETING_PARTNER_LISTING_UPDATE_STATUS_TEMPORARILY_OFF_MARKET}`
            }
          >
            <SrBox
              backgroundColor="rgba(255, 255, 255, 0.85)"
              borderRadius={isLandlord ? '0 0 14px 14px' : null}
            >
              <SrBox
                height="70px"
                paddingTop="20px"
                boxSizing="border-box"
                borderBottom={isLandlord ? null : '1px solid #a1a1a1'}
              >
                <SrText
                  color="blue300"
                  font="greycliff"
                  fontSize="26px"
                  align="center"
                  weight="800"
                  display="block"
                >
                  Temporarily Off-Market
                </SrText>
              </SrBox>
            </SrBox>
          </SrLink>
          {!isLandlord && (
            <SrBox
              backgroundColor="rgba(255, 255, 255, 0.85)"
              borderRadius="0 0 14px 14px"
              onClick={isAdmin ? onAdminWithdrawClick : onWithdrawClick}
              cursor="pointer"
            >
              <SrBox height="70px" paddingTop="20px" boxSizing="border-box">
                <SrText
                  color="red"
                  font="greycliff"
                  fontSize="26px"
                  align="center"
                  weight="800"
                  display="block"
                >
                  Withdraw
                </SrText>
              </SrBox>
            </SrBox>
          )}
        </SrBox>
        <SrBox
          margin="18px 10px 0 10px"
          backgroundColor="rgba(255, 255, 255, 0.3)"
          borderRadius="14px"
          height="70px"
          paddingTop="21px"
          boxSizing="border-box"
          onClick={onClose}
          cursor="pointer"
        >
          <SrText
            color="white"
            font="greycliff"
            fontSize="26px"
            align="center"
            weight="800"
            display="block"
          >
            Cancel
          </SrText>
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrPartnerMarketingListingStatusUpdateModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onWithdrawClick: PropTypes.func.isRequired,
  partner: PropTypes.object.isRequired,
  marketingPartnerListing: PropTypes.object.isRequired,
};

SrPartnerMarketingListingStatusUpdateModal.displayName =
  'SrPartnerMarketingListingStatusUpdateModal';

export default SrPartnerMarketingListingStatusUpdateModal;
